import React, { Component } from 'react';

class BecasTable extends Component {
    state = {
        boton1: {
            icono: "fa fa-share-square-o",
            texto: "Ver Detalles"
        },
    }

    verDetalles = (datos) => {
        this.setState({
            boton1: {
                icono: "fa fa-spinner fa-spin",
                texto: "Espera"
            }
        }, () => {
            this.props.funcionDetalle(datos);
            this.setState ({
                boton1: {
                    icono: "fa fa-share-square-o",
                    texto: "Ver Detalles"
                },
            })
        })
    }

    render() {
        let { boton1 } = this.state;
        let { datos } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (n1, n2, a1, a2) => {
            let nombre2 = "";
            let apellido2 = "";
            if (n2 !== null) nombre2 = n2;
            if (a2 !== null) apellido2 = a2;
            return `${n1} ${nombre2} ${a1} ${apellido2}`;
        }

        let tipoBeca = (tipo) => {
            switch (tipo) {
                case "1": return "BECA COMPLETA"
                case "2": return "MEDIA BECA"
                case "3": return "BECA TRABAJO"
                default : return "BECA COMPLETA"
            }
        }

        return (
            <React.Fragment>
                <tr>
                    <td width="50%" style={styles}>{nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</td>
                    <td align="center" style={styles}>{datos.carrera_name}</td>
                    <td align="center" style={styles}>{tipoBeca(datos.tipo)}</td>
                    <td align="center" style={styles}>
                        <button className="btn btn-primary" onClick={() => {this.verDetalles(datos)}} style={{borderWidth: 1}}><i className={boton1.icono}></i> {boton1.texto}</button>
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}
 
export default BecasTable;


// WEBPACK FOOTER //
// ./src/views/Bienestar/BecasTable.jsx